@if (overlay.visible && account) {
  <div class="overlay">
    @if (!annotationsActive) {
      <div class="overlay__top-bar">
        <p class="overlay__counter">{{ overlay.index + 1 }} / {{ overlay.elements.length }}</p>
        <div class="overlay__actions">
          @if (
            !annotationsActive &&
            (workspace?.share.shareOption === EUserRole.OWNER ||
            workspace?.share.shareOption === EUserRole.SITE_ADMIN ||
            workspace?.share.shareOption === EUserRole.NORMAL ||
            workspace?.share.shareOption === EUserRole.ACCOUNT_ADMIN) &&
            overlay.elements[overlay.index]?.type === 'Image' &&
            !isMobile &&
            !isTablet
            ) {
            <div
              ppTooltip
              role="button"
              aria-label="Annotate"
              class="overlay__actions__item"
              ppTitle="Annotate"
              (click)="addAnnotation(true)"
              >
              <img class="overlay_actions_itemIcon" [src]="EIconPath.GALLERY_FREE_DRAWING" />
            </div>
          }
          @if (
            !annotationsActive &&
            (workspace?.share.shareOption === EUserRole.OWNER ||
            workspace?.share.shareOption === EUserRole.SITE_ADMIN ||
            workspace?.share.shareOption === EUserRole.NORMAL ||
            workspace?.share.shareOption === EUserRole.ACCOUNT_ADMIN) &&
            overlay.elements[overlay.index]?.type === 'Image'
            ) {
            <pp-image-rotation
              ppTooltip
              ppTitle="Rotate Image"
              class="overlay__actions__item"
              [ppClockwise]="true"
              [ppImageId]="overlay.elements[overlay.index]?.id"
              [ppOverlayIndex]="overlay.index"
              [ppRotationAngle]="overlay.elements[overlay.index]?.rotationAngle"
              [ppImageName]="overlay.elements[overlay.index]?.fileName"
              [ppImageMimeType]="overlay.elements[overlay.index]?.mimeType"
              [ppImageCreatedOn]="overlay.elements[overlay.index]?.createdOn"
              (ppRotationAngleChanged)="rotateImage($event)"
              [ppPointId]="point._id"
            ></pp-image-rotation>
          }
          @if (
            !annotationsActive &&
            (workspace?.share.shareOption === EUserRole.OWNER ||
            workspace?.share.shareOption === EUserRole.SITE_ADMIN ||
            workspace?.share.shareOption === EUserRole.NORMAL ||
            workspace?.share.shareOption === EUserRole.ACCOUNT_ADMIN) &&
            overlay.elements[overlay.index]?.type === 'Image'
            ) {
            <pp-image-rotation
              ppTooltip
              ppTitle="Rotate Image"
              class="overlay__actions__item"
              [ppClockwise]="false"
              [ppImageId]="overlay.elements[overlay.index]?.id"
              [ppOverlayIndex]="overlay.index"
              [ppRotationAngle]="overlay.elements[overlay.index]?.rotationAngle"
              [ppImageName]="overlay.elements[overlay.index]?.fileName"
              [ppImageMimeType]="overlay.elements[overlay.index]?.mimeType"
              [ppImageCreatedOn]="overlay.elements[overlay.index]?.createdOn"
              (ppRotationAngleChanged)="rotateImage($event)"
              [ppPointId]="point._id"
            ></pp-image-rotation>
          }
          @if (overlay.elements[overlay.index]?.type === 'Image') {
            <div
              ppTooltip
              role="button"
              aria-label="Zoom"
              class="overlay__actions__item"
              [ngClass]="{ 'overlay_actions_item--active': isZoomed }"
              ppTitle="Zoom"
              (click)="zoomImage()"
              >
              @if (!isZoomed) {
                <img class="overlay_actions_itemIcon" [src]="EIconPath.GALLERY_ZOOM" />
              }
              @if (isZoomed) {
                <div class="overlay_actions_itemIcon">
                  <img class="" [src]="EIconPath.GALLERY_ZOOM_OUT" alt="" />
                </div>
              }
            </div>
          }
          <div
            ppTooltip
            role="button"
            aria-label="Download"
            class="overlay__actions__item"
            ppTitle="Download"
            (click)="downloadImage()"
          >
            <img class="overlay_actions_itemIcon" [src]="EIconPath.GALLERY_DOWNLOAD" />
          </div>
          @if (canDelete) {
            <div
              ppTooltip
              role="button"
              aria-label="Delete"
              class="overlay__actions__item"
              ppTitle="Delete"
              (click)="deleteImage()"
              >
              <img class="overlay_actions_itemIcon" [src]="EIconPath.GALLERY_DELETE" />
            </div>
          }
          <div
            ppTooltip
            role="button"
            aria-label="Close"
            class="overlay__actions__item imageClose__btn"
            [ngClass]="{ 'overlay__btn--disabled': annotationsActive }"
            ppTitle="Close (Esc)"
            (click)="hide(); $event.stopPropagation()"
            >
            <img class="overlay_actions_itemIcon" [src]="EIconPath.GALLERY_CLOSE" />
          </div>
        </div>
      </div>
    }
    <img
      ppTooltip
      role="button"
      aria-label="Previous"
      class="overlay__btn--left"
    [ngClass]="{
      'overlay__btn--hidden': annotationsActive,
      'overlay__btn--disabled': overlay.elements.length === 1,
    }"
      [src]="EIconPath.GALLERY_GO_LEFT"
      (click)="previous(); $event.stopPropagation()"
      ppTitle="Previous"
      />
    <img
      ppTooltip
      role="button"
      aria-label="Next"
      class="overlay__btn--right"
    [ngClass]="{
      'overlay__btn--hidden': annotationsActive,
      'overlay__btn--disabled': overlay.elements.length === 1,
    }"
      [src]="EIconPath.GALLERY_GO_RIGHT"
      ppTitle="Next"
      (click)="next(); $event.stopPropagation()"
      />
    @if (overlay.elements[overlay.index]?.type === 'Image') {
      <div
        role="group"
        aria-label="Image"
        class="overlay__image-wrapper"
        (click)="$event.stopPropagation()"
        >
        <canvas #zoomCanvasElement id="zoomCanvasElement" class="overlay_zoomCanvasElement"></canvas>
        @if (
          annotationsActive &&
          (workspace?.share.shareOption === EUserRole.OWNER ||
          workspace?.share.shareOption === EUserRole.SITE_ADMIN ||
          workspace?.share.shareOption === EUserRole.NORMAL ||
          workspace?.share.shareOption === EUserRole.ACCOUNT_ADMIN) &&
          overlay.elements[overlay.index]?.type === 'Image' &&
          !isMobile &&
          !isTablet
          ) {
          <pp-image-annotations
            [ppImageId]="overlay.elements[overlay.index]?.id"
            [ppWidth]="overlay.elements[overlay.index]?.w"
            [ppHeight]="overlay.elements[overlay.index]?.h"
            [ppOverlayIndex]="overlay.index"
            [ppImageName]="overlay.elements[overlay.index]?.fileName"
            [ppImageCreatedOn]="overlay.elements[overlay.index]?.createdOn"
            [ppRotationAngle]="overlay.elements[overlay.index]?.rotationAngle"
            (ppGetButtonsStatusChange)="addAnnotation($event)"
            (ppAnnotationSaving)="updateAnnotationSavingState($event)"
            (ppAnnotationAdded)="updateImageWithAnnotation($event)"
            (ppRotationAngleChanged)="rotateImage($event)"
            [ppPointId]="point._id"
            >
          </pp-image-annotations>
        }
        <img
          ppImage
          #imageElement
          (ppOnRendered)="onImageElementRendered($event)"
          id="imageElement"
          class="overlay__img"
      [ngClass]="{
        'overlay__img--rotate-90deg':
          tempRotation?.rotation || tempRotation?.rotation === 0
            ? tempRotation.rotation === 90
            : overlay.elements[overlay.index]?.rotationAngle === 90,
        'overlay__img--rotate-180deg':
          tempRotation?.rotation || tempRotation?.rotation === 0
            ? tempRotation.rotation === 180
            : overlay.elements[overlay.index]?.rotationAngle === 180,
        'overlay__img--rotate-270deg':
          tempRotation?.rotation || tempRotation?.rotation === 0
            ? tempRotation.rotation === 270
            : overlay.elements[overlay.index]?.rotationAngle === 270,
        'overlay__img--fullscreen': !annotationsActive,
      }"
          [src]="loadedURL"
          />
        <img
          [src]="overlay.elements[overlay.index]?.base64src"
          (load)="loadImage(overlay.elements[overlay.index])"
          hidden
          />
      </div>
    }
    @if (overlay.elements[overlay.index]?.type === 'Image360') {
      <div
        role="group"
        aria-label="360 image"
        (click)="$event.stopPropagation()"
        >
        <pp-gallery-overlay-spherical
          [ppImageId]="overlay.elements[overlay.index]?.id"
        ></pp-gallery-overlay-spherical>
      </div>
    }
    @if (overlay.elements[overlay.index]?.type === 'Video') {
      <div
        role="group"
        aria-label="Video"
        class="overlay__video-wrapper"
        (click)="$event.stopPropagation()"
        >
        <pp-gallery-overlay-video
          [ppVideo]="overlay.elements[overlay.index]"
        ></pp-gallery-overlay-video>
      </div>
    }
  </div>
}
